const dataExport = {
  export: 'Export',
  errorMessage: 'Data export encountered unexpected errors.',
  waitForDownloadMessage: 'Request sent, your download will start shortly.',
  exportToCsv: {
    title: 'Export CSV',
    body: 'You are about to export a CSV file for {{selectedCount}} {{itemsLabel}}.',
  },
};

export default dataExport;
